export default __webpack_public_path__ + "static/media/reading.903df7c9.png";